import styled, { keyframes } from "styled-components";

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const SpinnerWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

export const SpinnerElement = styled.div`
  width: ${(props) => props.size || "60px"};
  height: ${(props) => props.size || "60px"};
  border: 6px solid #d1d5db;
  border-top-color: rgb(10 92 86);
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;